module.exports = __webpack_public_path__ + "static/oak_tree-47e3f6aa224b6ef49c76032cfa85d4c2.jpg";